import { render, staticRenderFns } from "./ManagerPage.vue?vue&type=template&id=2d0a5dfa&lang=pug&"
import script from "./ManagerPage.vue?vue&type=script&lang=js&"
export * from "./ManagerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports